const isUtc = ({ timezone }) => {
  return timezone === 1 ? false : true;
};

export default isUtc;
